import { useQuery } from '@tanstack/react-query';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { getDemandDerivationSelect } from '../api/demandDerivationApi';

type QueryFnType = typeof getDemandDerivationSelect;

type UseDemandDerivationSelectOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useDemandDerivationSelect = ({ config = {} }: UseDemandDerivationSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['demandDerivationSelect', i18n.language],
        queryFn: () => getDemandDerivationSelect(),
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};
